
var Buffer = require('buffer/').Buffer 

export async function downloadAveBlob(name = 'billete.pkpass', passBook:any) {

    // const blob: any = await getBlob()
    
    // const decodedBlob = atob(passBook);

    //PASSbOOK = BASE64
    
    const decodedBlob = Buffer.from(passBook, 'base64');

    const blob = new Blob([decodedBlob], {type:"application/vnd.apple.pkpass"})

    const blobUrl = window.URL.createObjectURL(blob);

    const link = document.createElement("a");

    link.href = blobUrl;

    link.download = name;

    document.body.appendChild(link);

    link.dispatchEvent(

        new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        })
    );
    document.body.removeChild(link);
}

  